import React, { memo } from 'react';
import {
  Shimmer,
  ShimmerSize,
  ShimmerType,
  ShimmerLength,
} from '../shimmer/shimmer';
import bemify from '../../utils/bemUtils';

/**
 * Represents the skeleton page for the home page.
 */
const SuggestionsSkeleton = memo(function SuggestionsSkeleton() {
  const [block, element] = bemify('suggestions-skeleton');

  return (
    <div className={block()}>
      <section className={element('use-location')}>
        <Shimmer type={ShimmerType.round} size={ShimmerSize.extraSmall} />
        <Shimmer
          type={ShimmerType.line}
          size={ShimmerSize.large}
          length={ShimmerLength.percent50}
        />
      </section>
      <Shimmer
        type={ShimmerType.line}
        size={ShimmerSize.large}
        length={ShimmerLength.percent100}
      />
      <Shimmer
        type={ShimmerType.line}
        size={ShimmerSize.large}
        length={ShimmerLength.percent100}
      />
    </div>
  );
});

export default SuggestionsSkeleton;
